/*
 * Copyright (c) 2025. Jellybean B.V.
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* fullselect.module.ts
* 2-12-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* <input sihwFullselect>
* Bij focus selecteert de input zijn waarde
*/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Fullselectdirective} from './fullselectdirective';

@NgModule({
  declarations: [
    Fullselectdirective
  ],
  imports: [
    CommonModule
  ],
  exports: [Fullselectdirective]
}) export class SiwhFullselectModule {}
